import React, { Component } from 'react'
import styled from 'styled-components'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import isArray from 'lodash/isArray'
import findIndex from 'lodash/findIndex'
import map from 'lodash/map'
import remove from 'lodash/remove'
import onClickOutside from 'react-onclickoutside'

/**
 * Select component
 */
class Select extends Component {
  constructor() {
    super()
    this.state = {
      listOpened: false,
      selected: null,
    }

    this.toggleList = this.toggleList.bind(this)
    this.setSelectedFromProp = this.setSelectedFromProp.bind(this)
  }

  handleClickOutside(evt) {
    if (this.state.listOpened) {
      this.setState({ listOpened: !this.state.listOpened })
    }
  }

  setSelectedFromProp(prop, first) {
    if (prop) {
      let selected
      if (isArray(prop)) {
        selected = map(prop, (propValue) =>
          find(this.props.items, ({ value }) => value === propValue)
        )
      } else {
        selected = find(this.props.items, ({ value }) => value === prop)
      }

      if (selected) {
        this.setState({ selected }, () => {
          if (isArray(selected)) {
            this.props.onChange && this.props.onChange(this.state.selected)
          } else {
            this.props.onChange &&
              this.props.onChange({ ...this.state.selected, first })
          }
        })
      }
    }
  }

  componentWillMount() {
    this.setSelectedFromProp(this.props.selected, true)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected) {
      const findItem = find(
        this.props.items,
        ({ value }) => value === nextProps.selected
      )
      if (findItem) {
        if (isEqual(this.state.selected, findItem)) {
          return false
        }

        this.setSelectedFromProp(nextProps.selected)
      }
    } else {
      this.setState({ selected: null })
    }
  }

  toggleList() {
    this.setState({ listOpened: !this.state.listOpened })
  }

  selectItem(item) {
    this.setState({ selected: item, listOpened: false }, () => {
      this.props.onChange && this.props.onChange(this.state.selected)
    })
  }

  selectItems(item) {
    let items = this.state.selected || []

    const found = findIndex(items, (i) => i.value === item.value)

    if (this.props.removedSelectOnSelected) {
      this.props.removedSelectOnSelected.forEach((v) =>
        remove(items, { value: v })
      )
    }

    if (this.props.excludeAllExceptOnSelect) {
      const isExluder = this.props.excludeAllExceptOnSelect.find(
        (it) => it === item.value
      )
      if (isExluder) {
        this.props.excludeAllExceptOnSelect.forEach((v) =>
          remove(items, (item) => item.value !== v)
        )
      }
    }

    if (found !== -1) {
      items = items.filter((item, index) => index !== found)
    } else {
      items.push(item)
    }

    this.setState({ selected: items }, () => {
      this.props.onChange && this.props.onChange(this.state.selected)
    })
  }

  render() {
    let {
      placeholder,
      render,
      Selector,
      List,
      className,
      items,
      extraClick,
    } = this.props

    let SelectorText = placeholder

    // Set default
    if (!Selector) {
      Selector = DefaultSelector
    }

    if (!List) {
      List = DefaultList
    }

    if (this.state.listOpened) {
      List = DefaultListOpened
    }
    if (this.state.selected) {
      if (this.state.selected.icon) {
        SelectorText = (
          <span>
            {typeof this.state.selected.icon === 'string' ? (
              <Icon
                src={this.state.selected.icon}
                alt={this.state.selected.label}
              />
            ) : (
              this.state.selected.icon
            )}
            {this.state.selected.label}
          </span>
        )
      } else {
        SelectorText = this.state.selected.label
      }
    }

    return (
      <Wrapper className={className}>
        <Selector
          onClick={() => {
            if (!this.props.disabled) {
              this.toggleList()
            }
            if (extraClick) {
              extraClick()
            }
          }}
          className={this.state.selected && 'selected'}
          icon={this.props.icon}
          disabled={this.props.disabled}>
          {render
            ? render(SelectorText, placeholder)
            : SelectorText
            ? SelectorText
            : placeholder}
          {this.props.arrowIcon && (
            <DropdownArrow opened={this.state.listOpened}>
              {<this.props.arrowIcon width={12} height={12} />}
            </DropdownArrow>
          )}
        </Selector>
        <List>
          {items &&
            items.map((item) => (
              <Item
                key={`item-${item.value}${item.label}`}
                onClick={() =>
                  SelectorText ? this.selectItem(item) : this.selectItems(item)
                }>
                {item.icon && typeof item.icon === 'string' ? (
                  <Icon src={item.icon} />
                ) : (
                  item.icon
                )}
                {item.value ===
                (this.state.selected && this.state.selected.value) ? (
                  <div>
                    {item.label} <span className={`itemSelected`}>✓</span>
                  </div>
                ) : (
                  item.label
                )}
              </Item>
            ))}
        </List>
      </Wrapper>
    )
  }
}
export default onClickOutside(Select)

export const Icon = styled.img`
  width: 35px;
  height: 35px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
`

export const Wrapper = styled.div`
  position: relative;
`

export const DefaultSelector = styled.div`
  padding: 15px 16px;
  font-size: 14px;
  line-height: 18px;
  font-weight: bold;
  background-color: #ffffff;
  color: #9c9c9c;
  display: flex;
  align-items: center;
  background-position: right center;
  background-repeat: no-repeat;
  border: 1px solid #efefef;
  cursor: pointer;
  position: relative;

  &.selected {
    color: #3e3e3e;
    font-weight: bold;
  }

  &[disabled] {
    background-color: transparent;
    border: 0;
    color: #676767;
    opacity: 0.5;
    pointer-events: none;
  }

  &:focus {
    border-color: #93c13e;
  }

  background-position: 16px center;
  background-repeat: no-repeat;
  background-size: 16.5px;

  ${(props) => (props.icon ? `background-image: url(${props.icon});` : '')}
  ${(props) => (props.icon ? `padding-left: 40px` : '')}
`

const DropdownArrow = styled.span`
  display: block;
  width: 12px;
  height: 12px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);

  > svg,
  path {
    fill: #616161;
  }

  ${(props) =>
    props.opened &&
    `
    transform: translateY(-50%)rotate(180deg);
  `}
`

export const DefaultList = styled.div`
  height: 0;
  opacity: 0;
  width: 100%;
  max-height: 200px;
  overflow: auto;
  border: 1px solid #efefef;
  border-top: 0;
  border-radius: 0 2px 2px 0;
  box-shadow: 0 0 0 1px #efefef;
  transition: all 0.4s ease-in-out;
  background: #fff;
  position: absolute;
  z-index: 99999;
`

export const DefaultListOpened = styled(DefaultList)`
  height: auto;
  opacity: 1;
  transition: all 0.4s ease-in-out;
`

export const Item = styled.div`
  padding: 10px 15px;
  transition: all 0.2s ease;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  white-space: nowrap;

  &:hover {
    background-color: #efefef;
  }
`

export const Checkbox = styled.span`
  border: 1px solid #bababa;
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;

  ${(props) =>
    props.checked
      ? `
    &:after {
      content: "✓";
      color: #93C13E;
      display: block;
      width: 18px;
      font-size: 18px;
      text-align: center;
      line-height: 18px;
    }
  `
      : ''}
`



// WEBPACK FOOTER //
// ./src/components/SelectV2/index.js